import $http from '../../axios';
import {Notification} from 'element-ui';
import {getApiDomain, getDomain} from "../../util/domains";

export async function downloadTemplate({}) {
    var data = ["SEDE", "BODEGA", "UBICACION", "CODIGO", "codigo anterior", "DESCRIPCION","SALDO UNDS", "COSTO UNITARIO","SALDO VALORES"];

    var csv = "";
    data.map((v, i) => {
        csv += `${v};`;
    });
    csv =   csv.substring(0, csv.length - 1)
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = "saldos_iniciales.csv";
    hiddenElement.click();
}
export async function fetchBranchOfficesWarehouses({state,commit}) {
    commit('setPreloader', true);
    await $http.get('/api/branchs-ware-by-id/'+state.params.branchoffice_id)
        .then((response) => {
            commit('setBranchofficesWarehouses', response.data.data);
            commit('setPreloader', false);
        })
        .catch((error) => {
            commit('setPreloader', false);
            console.error(error);
        });
}
export async function fetchValidates_file({state,commit}) {
    let formData = new FormData();
    commit('setPreloader', true);
    formData.append('branchoffice_id', state.params.branchoffice_id);
    formData.append('validated', state.params.validated);
    formData.append('branchoffice_warehouse_id', state.params.branchoffice_warehouse_id);
    formData.append('file', state.params.file);

    $http.post(`/api/incorporar-saldos-iniciales-inventario`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then((response) => {

        commit('setPreloader', false);
        if (state.params.validated) {
            Notification.success({
                title: "Success!",
                message: response.data,
                type: "success",
                duration: 4000,
                customClass: "notification-box"
            });
            commit('reset_state');
        }
        else{
            commit('setValidationdata', response.data);
            if (!response.data.success) {
                window.open(getApiDomain() + response.data.url_report_error, '_blank');
                Notification.error({
                    title: "Error!",
                    message: 'El excel tiene informacion de otra sede /bodega y/o contiene productos inexistentes, por favor valida el excel con los errores encontrados',
                    type: "error",
                    duration: 10000,
                    customClass: "notification-box"
                });
            } else {
                Notification.success({
                    title: "Success!",
                    message: 'Validación Finalizada exitosamente',
                    type: "success",
                    duration: 4000,
                    customClass: "notification-box"
                });
            }
        }

    }).catch(error => {
        commit('setPreloader', false);
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}




// WEBPACK FOOTER //
// ./src/modules/incorporate_inventory_initial_balance/actions.js